<template>
  <div>
    <notice
      :showPreloader="showPreloader"
    ></notice>
    <smc7-component
      :showPreloader="showPreloader"
      :skusList="skusList"
      v-if="queryParams.tpl === 'smc7' || queryParams.tpl === 'smc7p'" />
    <vmc4-component
      :showPreloader="showPreloader"
      :skusList="skusList"
      v-else-if="queryParams.tpl === 'vmc4'" />
    <fmc5
      :showPreloader="showPreloader"
      v-else-if="queryParams.tpl === 'fmc5'" />
    <zmc10-component
      :showPreloader="showPreloader"
      :skusList="skusList"
      v-else-if="queryParams.tpl === 'zmc10'" />
    <emc1-component
      :showPreloader="showPreloader"
      :skusList="skusList"
      v-else />

    <preloader-3
      v-if="showPreloader"
      :countryCode="countryCode"
      :show-preloader.sync="showPreloader"/>
  </div>
</template>

<script>
import { t } from './utils/i18n';
import fmc5 from './components/fmc5'
import queryToComponent from './mixins/queryToComponent'

const showPreloader = (js_query_params.preload === '{preload}' || +js_query_params.preload === 3) && !js_query_params.coupon;

export default {
  name: 'app',
  data () {
    return {
      showPreloader,
      title: js_data.product.page_title,
      showSecondTitle: true, // this flag used for toggling exit-intent title switch
      additionalTitle: ' ' + t('checkout.page_title'),
      waitTitle: t('checkout.page_title.wait'),
      waitTitle2: t('checkout.page_title.wait2'),
      titleTimer: null,
    }
  },
  mixins: [queryToComponent],
  components: {
    fmc5,
  },
  provide(){
    return {
      countryCode: this.countryCode
    }
  },
  methods: {
    initial () {
      document.title = this.title + this.additionalTitle;
      window.onfocus = () => {
        document.title = this.title + this.additionalTitle;
        clearInterval(this.titleTimer);
      }
      window.onblur = () => {
        document.title = this.waitTitle;
        this.titleTimer = setInterval(() => {
          document.title = this.showSecondTitle ? this.waitTitle2 : this.waitTitle;
          this.showSecondTitle = !this.showSecondTitle;
        }, 4000);
      }
    },
  },
  computed: {
    countryCode() {
      return js_data.country_code;
    },
    skusList() {
      return Array.isArray(js_data.product.skus)
        ? js_data.product.skus
        : [];
    },
  },
  mounted () {
    localStorage.removeItem('order_currency');
    this.initial();
  },
}
</script>

<style lang="scss">

</style>
